import { paths } from 'config'
import { DrawerLocks } from 'shared/assets'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.locks,
    isSuperAdmin: true,
    exact: true,
    linkSettings: {
      icon: DrawerLocks,
      label: 'nav.locks',
      to: paths.locks,
    },
    component: Loadable({
      component: () => import('./pages/Locks'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.lock,
    admin: true,
    canShowOrganizations: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/Lock'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.lockEdit,
    admin: true,
    canShowOrganizations: true,
    exact: true,
    component: Loadable({
      component: () => import('./pages/LockEdit'),
    }),
    layoutSettings: {},
  },
]

export default routes
